import { FunCode } from '@/constants/funcode'
import service from '@/services'
import eventBus from '@/services/bus'
import { checkToken, stopCheckToken, checkTokenLoop } from '@/business/common'
import { MTP2WebSocket } from './build'
import { Package50 } from './package'
import { pushMessage50 } from './message'
import { encodeProto, decodeProto } from './package/package50/proto'

export default new (class {
    constructor() {
        this.socket.onClose = () => {
            // 停止令牌校验
            stopCheckToken()
        }

        this.socket.onBeforeReconnect = (count) => {
            // 停止令牌校验
            stopCheckToken()
            // 交易服务重连通知
            eventBus.$emit('TradeServerReconnectNotify', count)
        }

        this.socket.onReconnect = () => {
            // 重新进行令牌校验
            checkToken().then(() => {
                checkTokenLoop()
                // 交易服务重连成功通知
                eventBus.$emit('TradeServerReconnectSuccessNotify')
            })
        }

        this.socket.onPush = (pkg) => pushMessage50(pkg, 'encrypted')
    }

    /** 交易链路 */
    private socket = new MTP2WebSocket(Package50);

    async connect() {
        const res = await service.onReady()
        await this.socket.connect(res.tradeUrl)
    }

    /**
     * 向交易服务器发送请求
     * @param params
     * @returns 
     */
    async send<T>({ data, requestCode, responseCode }: {
        data: unknown;
        requestCode: keyof typeof FunCode;
        responseCode: keyof typeof FunCode;
    }) {
        const requestId = FunCode[requestCode]
        const responseId = FunCode[responseCode]

        // 请求之前确保重连后 token 是有效的
        if (requestCode !== 'TokenCheckReq' && requestCode !== 'LoginReq' && this.socket.connState !== 'Connected') {
            await checkToken()
        }

        return new Promise<T>((resolve, reject) => {
            encodeProto(requestCode, data).then((res) => {
                this.connect().then(() => {
                    this.socket.send({
                        data: {
                            rspCode: responseId,
                            payload: new Package50(requestId, res)
                        },
                        success: (raw) => {
                            decodeProto<T>(responseCode, raw.content).then((res) => {
                                resolve(res)
                            }).catch(() => {
                                console.error(responseCode, raw)
                                reject('Parsing failed')
                            })
                        },
                        fail: (err) => {
                            console.error(requestCode, err)
                            reject(err)
                        }
                    })
                }).catch(() => {
                    reject('Service connection failed')
                })
            }).catch((msg) => {
                console.error(requestCode, msg)
                reject('Build failed')
            })
        })
    }

    /**
     * 关闭交易链路
     */
    close() {
        this.socket?.close()
    }
})